
export async function dataURItoBlob(bas64Image) 
{
    let url = bas64Image;
    let res = await fetch(url);
    let blob = await res?.blob();
    return blob;
}

export async function base64toBlob(base64String)
{
    let url = base64String;
    let res = await fetch(url);
    let blob = await res?.blob();
    return blob;
}